import dom from "../../../../../../common/ts/core/dom";
import retentionFormActions from './actions';
import localStorage from "../../../../../../common/ts/core/localStorage";
import {
   EMAIL_RETENTION_FORM_IDS,
   EMAIL_RETENTION_TOGGLE_IDS
} from "../main/constants";
function init(
    emailRetentionToggleTrackingName: string,
    emailRetentionSubmitTrackingName: string,
    isPaid: boolean,
    isDesktop: boolean,
    actions = retentionFormActions,
) {

   actions.init();
   const formsIds = EMAIL_RETENTION_FORM_IDS;
   const toggleIds = EMAIL_RETENTION_TOGGLE_IDS;

   formsIds.forEach(formId => actions.initializeRetentionForm(formId, localStorage.getItem("email")))

   toggleIds.forEach(toggleId => {
      const toggleButton = dom.select(`#${toggleId}`);
      toggleButton?.addEventListener("change", (changeEvent: Event) => {
         const eventTarget = changeEvent.currentTarget as HTMLInputElement;

         actions.changeRetentionToggle(eventTarget, emailRetentionToggleTrackingName);
      });
   });

   formsIds.forEach(formId => {
      const formElement = dom.select(`#${formId}`) as HTMLFormElement;
      formElement?.addEventListener("submit", (event) => {
         event.preventDefault();
         const formData = new FormData(formElement);
         const openedFrom = formElement.dataset.formOriginOpenedFrom;

         actions.submitRetentionForm(
             formId,
             formData,
             emailRetentionSubmitTrackingName,
             isPaid,
             openedFrom ? openedFrom : "",
             isDesktop,
         )
      });
   });
}

export default {
   init,
}
